/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as VerificationDefs from './defs.defs.js'

const $nsid = 'tools.ozone.verification.grantVerifications'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  verifications: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<VerificationInput>((() => verificationInput) as any),
    { maxLength: 100 },
  ),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  verifications: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<VerificationDefs.VerificationView>(
      (() => VerificationDefs.verificationView) as any,
    ),
  ),
  failedVerifications: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<GrantError>((() => grantError) as any),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Grant verifications to multiple subjects. Allows batch processing of up to 100 verifications at once. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }

type VerificationInput = {
  $type?: 'tools.ozone.verification.grantVerifications#verificationInput'

  /**
   * The did of the subject being verified
   */
  subject: l.DidString

  /**
   * Handle of the subject the verification applies to at the moment of verifying.
   */
  handle: l.HandleString

  /**
   * Display name of the subject the verification applies to at the moment of verifying.
   */
  displayName: string

  /**
   * Timestamp for verification record. Defaults to current time when not specified.
   */
  createdAt?: l.DatetimeString
}

export type { VerificationInput }

const verificationInput = /*#__PURE__*/ l.typedObject<VerificationInput>(
  $nsid,
  'verificationInput',
  /*#__PURE__*/ l.object({
    subject: /*#__PURE__*/ l.string({ format: 'did' }),
    handle: /*#__PURE__*/ l.string({ format: 'handle' }),
    displayName: /*#__PURE__*/ l.string(),
    createdAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
  }),
)

export { verificationInput }

/** Error object for failed verifications. */
type GrantError = {
  $type?: 'tools.ozone.verification.grantVerifications#grantError'

  /**
   * Error message describing the reason for failure.
   */
  error: string

  /**
   * The did of the subject being verified
   */
  subject: l.DidString
}

export type { GrantError }

/** Error object for failed verifications. */
const grantError = /*#__PURE__*/ l.typedObject<GrantError>(
  $nsid,
  'grantError',
  /*#__PURE__*/ l.object({
    error: /*#__PURE__*/ l.string(),
    subject: /*#__PURE__*/ l.string({ format: 'did' }),
  }),
)

export { grantError }
